<div class="dashboard">
    <div class="container-fluid">
        <div class="row">
            <ng-content></ng-content>
        </div>
    </div>
</div>